import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import TabHeader from '../../Components/TabHeader/TabHeader';
import { useClient } from '../../../../api/api-client';
import { Skeleton } from '../../../../components/ComponentsV1/Skeleton/Skeleton';
import { RIDER_MISCONDUCT_ENDPOINT, SKELETON_ROWS } from './constants';
import ConfigResult from './Elements/ConfigResult';

const RiderMisconductConfig = () => {
  const client = useClient();

  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isActionLoading, setIsActionLoading] = useState(false);

  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [editModel, setEditModel] = useState('');
  const [editPrompt, setEditPrompt] = useState('');

  const fetchConfig = async () => {
    const data = await client(RIDER_MISCONDUCT_ENDPOINT);
    if (data) setConfig(data);
  };

  useEffect(() => {
    setIsLoading(true);
    fetchConfig()
      .catch(() => toast.error('Failed to fetch config'))
      .finally(() => setIsLoading(false));
  }, []);

  const handleUpdate = async () => {
    setIsActionLoading(true);
    try {
      await client(RIDER_MISCONDUCT_ENDPOINT, {
        data: { prompt: editPrompt, model: editModel },
      });
      toast.success('Config updated successfully');
      setIsUpdateMode(false);
      await fetchConfig().catch(() => {});
    } catch (error) {
      toast.error(error?.message || error?.detail || 'Failed to update config');
    } finally {
      setIsActionLoading(false);
    }
  };

  const handleDelete = async () => {
    setIsActionLoading(true);
    try {
      await client(RIDER_MISCONDUCT_ENDPOINT, { method: 'DELETE' });
      toast.success('Config deleted successfully');
      setShowDeleteConfirm(false);
      setConfig(null);
      await fetchConfig().catch(() => {});
    } catch (error) {
      toast.error(error?.message || error?.detail || 'Failed to delete config');
    } finally {
      setIsActionLoading(false);
    }
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10'>
      <div className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl'>
        <TabHeader
          title='Rider Misconduct Config'
          subTitle='View and manage prompt and model configuration for AI-powered rider misconduct detection'
        />

        {isLoading ? (
          <Skeleton rows={SKELETON_ROWS} />
        ) : config ? (
          <ConfigResult
            config={config}
            isActionLoading={isActionLoading}
            isUpdateMode={isUpdateMode}
            setIsUpdateMode={setIsUpdateMode}
            showDeleteConfirm={showDeleteConfirm}
            setShowDeleteConfirm={setShowDeleteConfirm}
            editModel={editModel}
            setEditModel={setEditModel}
            editPrompt={editPrompt}
            setEditPrompt={setEditPrompt}
            onUpdate={handleUpdate}
            onDelete={handleDelete}
          />
        ) : (
          <div className='tw-text-grey-500 tw-text-[1.4rem] tw-py-8'>
            No config found.
          </div>
        )}
      </div>
    </div>
  );
};

export default RiderMisconductConfig;
